export function handleMapMove(map, queryLayers, updateHoveredFeatures, updateState) {
  let hoveredFeatureIds = [];

  // Fonction qui traite l'événement 'move' et 'zoom'
  function handleMapInteraction() {
    const centerX = window.innerWidth / 2;
    const centerY = window.innerHeight / 2;

    // Récupère les entités rendues au centre de la carte
    const features = map.queryRenderedFeatures([centerX, centerY], {
      layers: queryLayers.map(layer => layer.layername),
    });

    const uniqueFeatures = {};
    features.forEach(feature => {
      const sourceLayer = feature.layer['source-layer'];
      if (!uniqueFeatures[sourceLayer]) {
        uniqueFeatures[sourceLayer] = feature;
      }
    });

    // Obtenir la liste des features uniques
    const hoveredFeatures = Object.values(uniqueFeatures);
    // Met à jour les entités survolées (pour le rendu, les infobulles, etc.)
    updateHoveredFeatures(hoveredFeatures);

    if (updateState) {
      // Désactive l'état "hover" pour les anciennes entités
      hoveredFeatureIds.forEach(({ source, sourceLayer, id }) => {
        map.setFeatureState({ source, sourceLayer, id }, { hover: false });
      });

      // Réinitialise la liste des ID des entités survolées
      hoveredFeatureIds = [];

      // Active l'état "hover" pour les nouvelles entités survolées
      hoveredFeatures.forEach(feature => {
        const { source, sourceLayer, id } = feature;
        if (id !== undefined) {
          map.setFeatureState({ source, sourceLayer, id }, { hover: true });
          hoveredFeatureIds.push({ source, sourceLayer, id });
        }
      });
    }
  }

  // Écoute les événements de mouvement (pan) et de zoom
  map.on('move', handleMapInteraction);
  map.on('zoom', handleMapInteraction);
}

export function getCenter(map, updateCenter) {
  map.on('move', () => {
    const mapCenter = map.getCenter();
    const center = {
      lat: mapCenter.lat.toFixed(5),
      lon: mapCenter.lng.toFixed(5)
    };
    updateCenter(center); // Utiliser une fonction callback pour envoyer les nouvelles coordonnées
  });
}


function toDMS(coordinate) {
  const degrees = Math.floor(coordinate);
  const minutes = Math.floor((coordinate - degrees) * 60);
  const seconds = ((coordinate - degrees - minutes / 60) * 3600).toFixed(2);
  return `${degrees}° ${minutes}' ${seconds}"`;
}

export function convertCenterToDMS(center) {
  const latDMS = toDMS(Math.abs(center.lat)) + (center.lat < 0 ? ' S' : ' N');
  const lonDMS = toDMS(Math.abs(center.lon)) + (center.lon < 0 ? ' W' : ' E');
  return `${latDMS}, ${lonDMS}`;
}